import React from 'react';
import {Link,withRouter} from 'react-router-dom';
import LOGO from '../logo.svg';
import { withTranslation } from 'react-i18next';
import { appConfig } from '../config/appConfig';

class PageNotFound extends React.Component{

    render(){

        const { history, t } = this.props;

        return (
            <div className="container" style={{paddingBottom:"50px"}}>
                <div style={{paddingTop:"150px", textAlign:"center"}}>
                    <Link to={'/'}>
                        <img
                            src={`/img/${appConfig.logoName}.svg`}
                            alt={t('common.imageLogoAltText', {
                                companyName: appConfig.companyName
                            })}
                            style={{width: "100%", maxWidth: "40rem"}}
                        />
                    </Link>
                </div>
                <div style={{textAlign:"center", fontSize:"200px", marginBottom:"10px", color:"#c5c4c4"}}>
                    404
                </div>
                <div style={{textAlign:"center", fontSize:"16px"}}>
                    {t("common.nothingToSee")}
                    <br/>
                    <br/>
                    <Link to={'#'} onClick={history.goBack}>{t("common.goBack")}</Link>
                </div>
            </div>
        )
    }
}

const PageNotFoundWithTranslation = withTranslation()(PageNotFound)
export default withRouter(PageNotFoundWithTranslation);